import React, { useState, useEffect, useLayoutEffect } from 'react';
import styles from './RewardsHistory.module.scss';
import { useTranslation } from 'react-i18next';
import { EventEarningsTable } from '../EventEarningsTable/EventEarningsTable';
import TowerTokenIcon from '../../assets/imgs/tower-token 1.png';
import { EventEarningsList } from '../EventEarningsList';
import { NoBattleCardsOwnedNotice } from '../ViewTower/NoBattleCardsOwnedNotice';

const RewardsHistory = (props) => {
    const { rewardsRecords, userBattleCardCount, userTicketCount } = props;
    const [t] = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const itemsInAPage = 8;
    const [rewardsHistoryRecords, setRewardsHistoryRecords] = useState([]);
    const [totalEventEarnings, setTotalEventEarnings] = useState(0);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        let totalItems = rewardsHistoryRecords.length;
        if (totalItems > 0) {
            setCurrentPage(1);
        }
        setTotalPages(Math.ceil(totalItems / itemsInAPage));
    }, [rewardsHistoryRecords]);

    useEffect(() => {
        (async () => {
            if (!rewardsHistoryRecords || rewardsHistoryRecords.length === 0) {
                setRewardsHistoryRecords(rewardsRecords?.data || []);
                setTotalEventEarnings(rewardsRecords?.totalTowerTokenEarned || 0)
            }
        })();
    }, [rewardsRecords]);

    const changePage = (jumpPage) => {
        if (jumpPage > 1) {
            setCurrentPage(totalPages);
        } else if (jumpPage < -1) {
            setCurrentPage(1);
        } else if (jumpPage < 0 && currentPage + jumpPage > 0) {
            setCurrentPage(currentPage + jumpPage);
        } else if (jumpPage > 0 && currentPage + jumpPage < totalPages + 1) {
            setCurrentPage(currentPage + jumpPage);
        }
    };

    useLayoutEffect(() => {
        window.addEventListener('resize', () => {setScreenWidth(window.innerWidth)});
    }, []);

    return (
        <div className={styles.rewards_history_container}>
                <div className={styles.section_title}>
                    <span className={styles.title_text}>{t('REWARDS_HISTORY')}</span>
                </div>
                <div className={styles.rewards_container_plus}>
                    <div className={styles.container_section_headers}>
                        <div className={styles.total_event_earning}>
                            <img src={TowerTokenIcon} alt="tower-token" />
                            <div>
                                <div>{t('TOTAL_EVENT_EARNINGS')}</div>
                                <div className={styles.token_count}>{Math.round(totalEventEarnings * 100) / 100}</div>
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: "0 16px 0 8px" }}>
                        <NoBattleCardsOwnedNotice battleCardsCount={userBattleCardCount} userTicketCount={userTicketCount} />
                    </div>

                    <div className={styles.rewards_container}>
                        <div className={styles.container_section_body}>
                            {
                                screenWidth > 768 ?
                                    <EventEarningsTable data={rewardsHistoryRecords.slice(itemsInAPage * (currentPage - 1), itemsInAPage * currentPage)} /> :
                                    <EventEarningsList data={rewardsHistoryRecords.slice(itemsInAPage * (currentPage - 1), itemsInAPage * currentPage)} />

                            }
                            <div className={styles.past_event_earnings_footer}>
                                <div className={styles.pagination_button} onClick={() => changePage(-1)}>&#60;</div>
                                <div className={styles.current_page_no}>{currentPage}</div>
                                <div className={styles.pagination_button} onClick={() => changePage(1)}>&#62;</div>
                                <div>{t('OF')} {totalPages}</div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    )
};

export { RewardsHistory };